(function ($, Drupal, once) {
    Drupal.behaviors.jsCasAccordion = {
      attach(context) {
        //const accordion = $('.accordion', context);
        const accordion = once('jsCasAccordion', '.accordion', context)
        const $accordion = $(accordion).each(function () {

            $(this).prev().children('.toggle-sign').addClass('closed');
            $('.accordion-content')
              .not('.v-hidden')
              .each(function () {
                $(this).css('height', $(this).outerHeight() + 'px');
              });

            $('.accordion-content').each(function () {
                $(this).addClass('v-hidden');
              });

            setTimeout(function() {
                $('.accordion-content').each(function () {
                    $(this).css('transition', "");
                })
            }, 200);
            // $('.accordion-content').first().removeClass('v-hidden');
            // $('.cas__toggle-bar').first().addClass('open');
  
          });
  
          $(window).resize(function () {
            $('.accordion-content')
              .not('.v-hidden')
              .each(function () {
                $(this).css('height', $(this).outerHeight() + 'px');
              });
          });
  
          const $toggleSign = $(accordion).bind('click', (event) => {
          if (event.target.className === 'toggle-sign closed') {
            $('.accordion-content').addClass('v-hidden');
            $('.toggle-sign').addClass('closed');
            $(event.target).parent().next().removeClass('v-hidden');
            $(event.target).removeClass('closed');
          } else if (event.target.className === 'cas__toggle-bar') {
            $('.accordion-content').addClass('v-hidden');
            $('.toggle-sign').addClass('closed');
            $(event.target).next().removeClass('v-hidden');
            $(event.target).children('.toggle-sign').removeClass('closed');
          }
        });
  
        $('.cas__toggle-bar').on('click', function(event) {
          event.stopPropagation();
          event.stopImmediatePropagation();
  
          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).trigger('blur');
            $(this).parent().next('.accordion-content').addClass('v-hidden');
  
          } else {
            $('.cas__toggle-bar').removeClass('open');
            $('.accordion-content').addClass('v-hidden');
            $(this).addClass('open');
            $(this).parent().next('.accordion-content').removeClass('v-hidden');
          }
        });
  
      },
    };
  })(jQuery, Drupal, once);
  